// extracted by mini-css-extract-plugin
module.exports = {"label":"SummaryModal_label__3cWXY","labelContent":"SummaryModal_labelContent__ImrY8","spinner":"SummaryModal_spinner__33cM9"};